function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["as", "children", "className", "compact", "hasFullWidthContent", "id", "labelA11y", "noBorderTop", "collapsible", "singleTab", "variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { uniqueId } from '@lmig/lmds-helpers/dist/uniqueId';
import { A11yOnly } from '@lmig/lmds-react-a11y';
import "./accordion.css";
import { AccordionContext } from './context';
/**
 * @see [LMDS Accordion documentation and examples](https://designsystem.lmig.com/components/accordions/code)
 *
 * API:
 *
 * @implements [AccordionProps](https://designsystem.lmig.com/components/accordions/code#accordion-props)
 * @extends [HTMLElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmlelement.html)
 */
export var Accordion = function Accordion(_ref) {
  var _classNames;
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    className = _ref.className,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    _ref$hasFullWidthCont = _ref.hasFullWidthContent,
    hasFullWidthContent = _ref$hasFullWidthCont === void 0 ? false : _ref$hasFullWidthCont,
    idProp = _ref.id,
    labelA11y = _ref.labelA11y,
    _ref$noBorderTop = _ref.noBorderTop,
    noBorderTop = _ref$noBorderTop === void 0 ? false : _ref$noBorderTop,
    _ref$collapsible = _ref.collapsible,
    collapsible = _ref$collapsible === void 0 ? true : _ref$collapsible,
    _ref$singleTab = _ref.singleTab,
    singleTab = _ref$singleTab === void 0 ? false : _ref$singleTab,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'standard' : _ref$variant,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(function () {
      return idProp || uniqueId('accordion');
    }),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    activeTabIDs = _useState4[0],
    setActiveTabIDs = _useState4[1];
  var accordionRef = useRef(null);
  var labelA11yId = "lmig-accordion-describedby-".concat(id);

  // function to handle the toggling of state for each individual accordion tab
  var handleActiveStateTab = function handleActiveStateTab(_ref2) {
    var elementID = _ref2.elementID,
      newTabState = _ref2.newTabState;
    setActiveTabIDs(function (prevState) {
      var included = prevState.includes(elementID);
      var newActiveIDs = prevState.map(function (prv) {
        return prv;
      });
      if (included) {
        // if included check to remove id from activeTabIDs
        newActiveIDs = singleTab ? [] : newActiveIDs.filter(function (prv) {
          return prv !== elementID;
        });
      } else if (singleTab && newTabState) {
        // if it's a singleTab and the newTabState coming in is true, we make only that tab active.
        newActiveIDs = [elementID];
      } else if (newTabState) {
        // if the newTabState is true and multiple tabs are allowed, we add to the activeTabIDs array
        newActiveIDs.push(elementID);
      } else {
        // if non of those conditions are true, we filter out the elementID to remove from activeTabIDs
        newActiveIDs = newActiveIDs.filter(function (actID) {
          return actID !== elementID;
        });
      }
      return newActiveIDs;
    });
  };

  // this effect takes care of the forceFirst that was present before
  useEffect(function () {
    if (!accordionRef || !singleTab || collapsible || activeTabIDs.length > 0) return;
    var current = accordionRef.current;
    var _current$querySelecto = current.querySelector('.lmig-Accordion-list-listItem-header-button'),
      buttonId = _current$querySelecto.id;
    handleActiveStateTab({
      elementID: buttonId,
      newTabState: true
    });
  }, [accordionRef, collapsible, singleTab]);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: classNames('lmig-Accordion', (_classNames = {}, _defineProperty(_classNames, "lmig-Accordion--".concat(variant), variant !== 'standard'), _defineProperty(_classNames, 'lmig-Accordion--compact', compact), _defineProperty(_classNames, 'lmig-Accordion--noBorderTop', noBorderTop), _defineProperty(_classNames, 'lmig-Accordion--hasFullWidthContent', hasFullWidthContent), _classNames), className),
    "aria-describedby": labelA11y ? labelA11yId : null,
    ref: accordionRef
  }, otherProps), /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: {
      accordionId: id,
      compact: compact,
      headingAs: as,
      activeTabIDs: activeTabIDs,
      collapsible: collapsible,
      setActiveState: handleActiveStateTab
    }
  }, labelA11y ? /*#__PURE__*/React.createElement(A11yOnly, {
    id: labelA11yId
  }, labelA11y) : null, /*#__PURE__*/React.createElement("ul", {
    className: classNames('lmig-Accordion-list')
  }, children)));
};
Accordion.propTypes = {
  /** Add an optional ID to this element: `<div class="lmig-Accordion">`. If none is provided, a unique ID will be generated. */id: _pt.string,
  /** Add custom classes to this element: `<div class="lmig-Accordion">`. */className: _pt.string,
  /** Set a non-visual label to be used by assistive technologies (e.g., screen readers)
     * for additional audio guidance. */
  labelA11y: _pt.string,
  /** If `true`, only one AccordionTab can be expanded at a time; clicking on another AccordionTab will
     * collapse the previously expanded AccordionTab. When paired with 'collapsible=false",
     * one and only one AccordionTab must be expanded at all times.
    @default false
    */
  singleTab: _pt.bool,
  /** If `true`, all AccordionTabs can be collapsed at the same time.
     * Otherwise, at least one AccordionTab must be expanded.
    @default true
    */
  collapsible: _pt.bool,
  /** Set compact styling.
    @default false
    */
  compact: _pt.bool,
  /** Turn off the top border.
    @default false
    */
  noBorderTop: _pt.bool,
  /** Use 'list' with shorter expanded content, or when you only have a single accordion on a page.
    @default 'standard'
    */
  variant: _pt.oneOf(['standard', 'list']),
  /** If `true`, the content within an Accordion will take full width.
     * Otherwise, padding will be added on the right side of the Accordion content to align it with the Accordion title.
    @default false
    */
  hasFullWidthContent: _pt.bool,
  /** Pass only AccordionTab components as children. Children are rendered in this element: `<ul class="lmig-Accordion-list">`. */children: _pt.node.isRequired
};
Accordion.displayName = 'Accordion';